import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import dxDataGrid from "devextreme/ui/data_grid";
import dxPivotGrid from "devextreme/ui/pivot_grid";
import dxChart from "devextreme/viz/chart"
import { PdfFont } from './PdfFont';
import toCanvas from 'canvg';
import { SvgUtils } from './svgUtils';
import { IReportOneUIComponent } from '../models/ReportTypes';
import ExtractorDataGridOptions from './ExtractorDataGridOptions';

//const imageUrl = "https://i.picsum.photos/id/566/200/300.jpg?hmac=gDpaVMLNupk7AufUDLFHttohsJ9-C17P7L-QKsVgUQU";

const getImageData = async (imageUrl) => {
    const response = await fetch(imageUrl)
    const imageBlob = await response.blob()
    const reader = new FileReader();
    reader.readAsDataURL(imageBlob);
    reader.onloadend = () => {
        const base64data = reader.result;
        console.log(base64data);
    }
}

const getElementProperty = (cssClass, headerId, propertyName) => {
    let elem = document.querySelector('.' + cssClass);
    if (!elem) {
        elem = document.querySelector('#' + headerId);
    }
    if (!elem) {
        return;
    }
    return getComputedStyle(elem).getPropertyValue(propertyName);
}
const setFontSizePdfCell = (gridCell, pdfCell) => {
    let res = getElementProperty(gridCell.column.cssClass, gridCell.column.headerId, "font-size");
    if (!res) return;
    let num = parseFloat(res);
    pdfCell.font.size = num;//Math.min(num, 12);
}

const setBorderWidthPdfCell = (gridCell, pdfCell) => {
    let res = getElementProperty(gridCell.column.cssClass, gridCell.column.headerId, "border-width");
    if (!res) return;
    let num = parseFloat(res);
    pdfCell.borderWidth = num;
}

const setShowBordersPdfCell = (gridCell, pdfCell) => {
    let drawLeftBorder =
        !(
        parseFloat((getElementProperty(gridCell.column.cssClass, gridCell.column.headerId, "border-left-width") || "")) == 0
        ||
        (getElementProperty(gridCell.column.cssClass, gridCell.column.headerId, "border-left-style") || "") == "none"
        );
    let drawRightBorder =
        !(
        parseFloat((getElementProperty(gridCell.column.cssClass, gridCell.column.headerId, "border-right-width") || "")) == 0
        ||
        (getElementProperty(gridCell.column.cssClass, gridCell.column.headerId, "border-right-style") || "") == "none"
        );
    let drawBottomBorder = 
        !(
        parseFloat((getElementProperty(gridCell.column.cssClass, gridCell.column.headerId, "border-bottom-width") || "")) == 0
        ||
    (getElementProperty(gridCell.column.cssClass, gridCell.column.headerId, "border-bottom-style") || "") == "none"
        );
    let drawTopBorder =
        !(
        parseFloat((getElementProperty(gridCell.column.cssClass, gridCell.column.headerId, "border-top-width") || "")) == 0
        ||
        (getElementProperty(gridCell.column.cssClass, gridCell.column.headerId, "border-top-style") || "") == "none"
        );
    pdfCell.drawLeftBorder = drawLeftBorder || drawRightBorder;
    pdfCell.drawRightBorder = drawLeftBorder || drawRightBorder;
    pdfCell.drawBottomBorder = true;
    pdfCell.drawTopBorder = drawTopBorder || drawLeftBorder || drawRightBorder;
}

const extractFileName = (reportName) => {
    const badSymbols = ["*", "?", ":", "\\", "/", "[", "]"];
    let repName = reportName;
    badSymbols.forEach(ch => {
        repName = repName.replaceAll(ch, " ");
    });
    return repName;
}
export default class ExporterToPdf {
    public static htmlToPdf = async (reportName, rootElementId) => {
        const element = document.getElementById(rootElementId);
        if (!element) {
            return;
        }
        window["html2pdf"]()
            .from(element)
            .save(reportName);
    }
//    public static exportToPdf = async (reportName, components: Array<dxDataGrid | dxPivotGrid | dxChart | any>) => {
    public static exportToPdf = async (reportName, components: Array<IReportOneUIComponent>) => {
        let repName = extractFileName(reportName);
        const doc = new jsPDF({
//            orientation: "portrait",
            orientation: "landscape",
            unit: "px",            
        })
        doc.addFileToVFS('verdana', PdfFont.fontNormal);
        doc.addFont('verdana', 'verdana', 'normal');
        doc.addFileToVFS('verdanab', PdfFont.fontBold);
        doc.addFont('verdanab', 'verdana', 'bold');
        doc.addFileToVFS('verdanai', PdfFont.fontItalic);
        doc.addFont('verdanai', 'verdana', 'italic');
        doc.setFont('verdana');
        doc.setFontSize(10);
//        doc.setFontSize(8);
        let maxY = 0;
        let pageNum = 0;
        for (let item of components) {
            if (!item) continue;
            if (!item.component) continue;
            if (item.component["_isHidden"] == true) continue;
            if (!((item.component["NAME"] == "dxDataGrid") || (item.component["NAME"] == "dxChart"))) continue;
            const pageMargin = {
                left: 15,
                top: 15,
                right: 15,
                bottom: 15,
            }
            pageNum++;
            const currTopLeft = () => {
                return {
                    x: 0,
                    y: Math.max(0, maxY - pageMargin.top + 0), 
                }
            }
            if (item.component["NAME"] == "dxDataGrid") {
                let component = item.component as dxDataGrid;
                let filterText = await ExtractorDataGridOptions.getFilterAndSearchText(component);
                if (filterText) {
                    const deltaH = 10;
                    const y = currTopLeft().y + pageMargin.top + deltaH;
                    let pageWidth = doc.internal.pageSize.getWidth() - pageMargin.left - pageMargin.right;
                    const { w, h } = doc.getTextDimensions(filterText, { maxWidth: pageWidth });
                    doc.text(filterText, currTopLeft().x + pageMargin.left, y,
                        {
                            maxWidth: pageWidth
                        }
                    );
                    maxY = maxY + h + deltaH;
                }
                console.log("maxY", maxY);
                await exportDataGridToPdf({
                    margin: pageMargin,
                    topLeft: currTopLeft(),
                    jsPDFDocument: doc,
                    component: item.component as dxDataGrid,
                    customizeCell({ gridCell, pdfCell }) {
                        //                        pdfCell.font.size = 8;
                        setShowBordersPdfCell(gridCell, pdfCell);
                        pdfCell.wordWrapEnabled = true;
                        //                            setFontSizePdfCell(gridCell, pdfCell);
                        if (gridCell.rowType == "data") {
//                            pdfCell.font.size = 8;
                            if (gridCell.column.cellTemplate == "templateImage") {
                                pdfCell.text = "";
                            }
                        }
                    },
                    customDrawCell(options) {
                        const { gridCell, pdfCell } = options;
                        if (gridCell.rowType == "data") {
                            if (gridCell.column.cellTemplate == "templateImage") {
                                let img = new Image();
                                img.src = gridCell.value;
                                doc.addImage(img,
                                    'png',
                                    options.rect.x, // + pdfCell.padding.left,
                                    options.rect.y,// + pdfCell.padding.top,
                                    options.rect.w,
                                    options.rect.h);
                            }
                        }
                        maxY = Math.max(maxY, options.rect.y + options.rect.h);
                    }

                });
            }
            else if (item.component["NAME"] == "dxChart") {
                //https://stackoverflow.com/questions/28450471/convert-inline-svg-to-base64-string
                let img = await SvgUtils.svgImageToPngImage((item.component as dxChart).svg());
                console.log("img", img);
                let pageWidth = doc.internal.pageSize.getWidth();
                let imageWidth = Math.min(img.width, pageWidth - pageMargin.left - pageMargin.right);
                let imageHeight = imageWidth * img.height / img.width;
                const y = currTopLeft().y + pageMargin.top;
                console.log("y", y);
                //                maxY = Math.max(maxY, imageHeight + pageMargin.top);
                doc.addImage(img.base64png, currTopLeft().x + pageMargin.left, y, imageWidth, imageHeight);
                maxY = maxY + imageHeight;
            }
        }
        if (pageNum > 0) {
            doc.save(repName + '.pdf');
        }
    };
}

